import "./SignIn.css";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoginDataService from "../../../Services/LoginService";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import Alert from "../../Controls/Alerts/Alerts";
// import { useCookies } from "react-cookie";
//import Recaptcha from './Captcha';
import Captcha from "./Captcha";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
  removeConfiguredData,
  setRPDLiteEnabled,
} from "../../../StateManagement/actions";
import { AppContext } from "../../../AppContext";
import { ModeFanOff } from "@mui/icons-material";
import MFAauthentication from "./MFAAuthentication";
import CaptchaDataService from "../../../Services/CaptchaDataService";


function SignIn() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  const location = useLocation();
  const mFAErrorMessage = location.state?.errorMessage;
  // const [cookies, setUserNameCookie] = useCookies([""]);
  // const [signCookie, settabCookie] = useCookies([""]);
  const Navigate = useNavigate();
  // settabCookie("TabSignIn", "SignIn");
  // let UserName = getCookie("UserName");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
  const [isBlurEventFired, setIsBlurEventFired] = useState(false);

  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSignIn", "Referesh");
  //   }
  //  }
  // if (
  // (UserTabCreate !="" || UserTabSend !=""  || UserTabDocumentHistory != "" || UserTabSignIn != "" || UserName != null ) || (UserName === null || localStorage.getItem("UserName") === undefined ||
  //  localStorage.getItem("UserName") != "" ||
  //  localStorage.getItem("UserName") != null)
  // ) {
  //   settabCookie("TabSignIn", "Signed");
  //   Navigate("send");
  // }

  const [openLoader, setOpen] = useState(true);
  useEffect(() => {
    localStorage.setItem("header", null);
    localStorage.setItem("UserName", "");
    localStorage.setItem("JWtToken", "");
    localStorage.setItem("UserRole", ""); // SignIn.js only
  }, []);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [timer, setTimer] = useState("");
  const [languageCode, setLanguageCode] = useState("en-us");
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [mfaPasswordPolicyData, setMFAPasswordPolicyData] = useState({});
  const emailRef = useRef(null);
  // const [captchaToken, setCaptchaToken] = useState(null);
  // const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const captchaRef = useRef(null);
  const [captchaValid, setCaptchaValid] = useState(false);
  useEffect(() => {
    var userbrowserlanguage = navigator.language.toLowerCase();
    switch (userbrowserlanguage) {
      case "da-dk":
        handlerLanguageCode("da-dk");
        break;
      case "nl-nl":
        handlerLanguageCode("nl-nl");
        break;
      case "fr-fr":
        handlerLanguageCode("fr-fr");
        break;
      case "de-de":
        handlerLanguageCode("de-de");
        break;
      case "it-it":
        handlerLanguageCode("it-it");
        break;
      case "pt-pt":
        handlerLanguageCode("pt-pt");
        break;
      case "es-es":
        handlerLanguageCode("es-es");
        break;
      case "ja-jp":
        handlerLanguageCode("ja-jp");
        break;
      default:
        handlerLanguageCode("en-us");
        break;
    }
    const searchParams = new URLSearchParams(document.location.search);
    let errorFound = false;
    for (const [key, value] of searchParams) {
      if (key === "errorReason") {
        setAlertMsg(decodeURIComponent(value));
        setAlertType("warning");
        errorFound = true;
        break;
      }
    }
    dispatch(removeConfiguredData());
  }, []);

  function handlerLanguageCode(dropSelectedLanguage) {
    setLanguageCode(dropSelectedLanguage);
    dispatch(languageChange(dropSelectedLanguage));
  }

  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }
  function submitFormWrapper() {
    if (!isBlurEventFired && AppContext.IsMFAandPasswordEnabled) {
      getMFAPassWordPolicyDetails(emailRef, false);
    }
    else {
      submitForm();
    }
  }

  async function submitForm(data, Emsg) {
    //const submitForm = async() => {
    // Prevent page reload
    if (!isBlurEventFired && AppContext.IsMFAandPasswordEnabled) {
      mfaPasswordPolicyData.enforcePasswordPolicy = data.enforcePasswordPolicy;
      mfaPasswordPolicyData.passwordChange = data.passwordChange;
      mfaPasswordPolicyData.mfaEnabled = data.mfaEnabled;
    }
    if (Emsg == AppContext.ErrorCodeForMobileNotProvided) {
      window.location.href = AppContext.REACT_APP_RportalUrl + "?email=" + email;
      return;
    }
    if (Emsg == AppContext.ErrorCodeForMobileNotVerified) {
      window.location.href = AppContext.REACT_APP_RportalOTPUrl + "?email=" + email + "&Id=NA&fromupdate=1";
      return;
    }
    if (email === "" || password === "") {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FieldsAreRequired + ".");
      setAlertType("warning");
      //alert("Email address or password are required");
      //document.getElementById("alertDanger").dis
      return;
    } else {
      setOpen(true);
      localStorage.setItem("UserName", email);
      localStorage.setItem("password", password);
      //login({ email, password })

      var loginData = {
        email: email,
        password: password,
        provider_Access_Token: null,
        passwordPolicyChange: 0,
        MFAEnabled: false
      };

      let response;
      //let response = await LoginDataService.Login(loginData);
      if ((((mfaPasswordPolicyData.enforcePasswordPolicy === 1 || mfaPasswordPolicyData.enforcePasswordPolicy === 2) && (mfaPasswordPolicyData.passwordChange == -1 || mfaPasswordPolicyData.passwordChange == 1)) || mfaPasswordPolicyData.mfaEnabled) && AppContext.IsMFAandPasswordEnabled) {
        response = await LoginDataService.MFALogin(loginData);
        if (response.response != undefined) {
          if (response.response.data.message.messageCode == "RCAP-1008") {
            setOpen(false);
            setAlertMsg(response.response.data.resultContent.errors[0].message);
            setAlertType("warning");
            return;
          }
          else if (response.response.data.message.message != undefined || response.response.data.message.message != "") {
            setOpen(false);
            setAlertMsg(response.response.data.message.message);
            setAlertType("warning");
            return;
          }
        }
        else {
          Navigate("/authenticating", {
            state: { response, mfaEnable: mfaPasswordPolicyData.mfaEnabled, isPasswordChange: mfaPasswordPolicyData.passwordChange },
          });
        }
      } else {
        response = await LoginDataService.Login(loginData);
      }
      if (response === "Server maintenance") {
        Navigate("/maintenance");
        return;
      } else if (response && response.status === 200) {
        localStorage.removeItem("DocumentID");
        localStorage.removeItem("ManageItem");
        localStorage.setItem("loginTimerCount", 0);
        localStorage.setItem("refresh_timer_count", 0);
        setOpen(false);
        localStorage.setItem("header", "1");
        localStorage.setItem("UserName", email);
        // setUserNameCookie("UserName", email);
        // settabCookie("TabSignIn", "Signed");

        setAlertType("sucess");
        localStorage.setItem("language", response.data.language);
        localStorage.setItem(
          "DateControlFormat",
          response.data.dateControlFormat
        );
        localStorage.setItem("UserRole", response.data.userRole);
        localStorage.setItem("Companyname", response.data.companyname);
        dispatch(setRPDLiteEnabled(response.data.rpdLite));
        localStorage.setItem("SecureSend", response.data.secureSend);
        //localStorage.setItem("showSettingTab", response.data.showSettingTab);

        var pendingrequest = localStorage.getItem("PendingRequest");
        var AiPendingrequest = localStorage.getItem("AIPendingRequest");
        if (
          (pendingrequest != null &&
            pendingrequest != "" &&
            pendingrequest == "true") ||
          (AiPendingrequest != null &&
            AiPendingrequest != "" &&
            AiPendingrequest == "true")
        ) {
          Navigate("history");
        } else {
          let landingPage = [];

          landingPage = response.data.landingPage.split("_");

          if (landingPage.length > 1) {
            localStorage.setItem("ManageItem", landingPage[1]);
            Navigate("history");
            return;
          }

          if (landingPage[0] === "Generate") Navigate("create");
          else Navigate(landingPage[0]);
        }
      } else {
        setOpen(false);
        if (
          response.response.data.errorMessage != undefined &&
          response.response.data.errorMessage != "" &&
          response.response.data.errorCode != undefined &&
          response.response.data.errorCode != "" &&
          response.response.data.errorCode == AppContext.ErrorCodeForPwdFailed && AppContext.IsMFAandPasswordEnabled
        ) {
          const response1 = await LoginDataService.MFALogin(loginData);
          Navigate("/authenticating", {
            state: { response: response1, mfaEnable: false, isPasswordChange: -1 },
          });
        }
        else if (
          response.response.data.errorMessage != undefined &&
          response.response.data.errorMessage != ""
        ) {
          setAlertMsg(response.response.data.errorMessage);
        } else
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_EmailAdressORpasswordNotValid
          );
        setAlertType("warning");
        //alert("Email address or password is not valid!");
      }
    }
  }

  // useEffect(() => {
  //   clearTimeout(timer);
  //   setTimer(
  //     setTimeout(() => {
  //       setAlertMsg("");
  //       setAlertType("");
  //     }, 5000)
  //   );
  // }, [alertType]);
  useEffect(() => {

    window.addEventListener("online", () => setOnlineStatus(true));
    window.addEventListener(
      "offline",
      () => setOnlineStatus(false),
      setOpen(false)
    );
    if (mFAErrorMessage && mFAErrorMessage != "") {
      setAlertMsg(mFAErrorMessage);
      setAlertType("warning");
      Navigate(location.pathname, { replace: true, state: {} })
      return;
    }
  }, []);
  let SSOVar = true;
  function SSOSignIn() {
    Navigate("/ssosignin", {
      state: { SSOVar },
    });
  }
  function getBrowserName() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("edg")) return "edge-desktop";
    if (userAgent.includes("chrome") && !userAgent.includes("edg")) return "chrome-desktop";
    if (userAgent.includes("firefox")) return "firefox-desktop";
    if (userAgent.includes("safari") && !userAgent.includes("chrome")) return "safari-desktop";

    return "unknown-browser";
  }

  const getMFAPassWordPolicyDetails = async (e, onblur) => {
    if (AppContext.IsMFAandPasswordEnabled) {
      var appDetails = {
        email: e.current.value,
        clientId: AppContext.ClientId,
        browserDevice: getBrowserName(),
      };

      if (email) {
        const data = await LoginDataService.MFAPasswordPolicy(appDetails);
        if (data.success) {
          setMFAPasswordPolicyData({ ...data });
          if (!onblur) {
            submitForm(data);
          }
          else {
            setIsBlurEventFired(true);
          }
        }
        else {
          if (data.response.data.message != null && data.response.data.message.messageCode == AppContext.ErrorCodeForMobileNotProvided && !onblur) {

            submitForm(data, data.response.data.message.messageCode);
          }
          else if (data.response.data.message != null && data.response.data.message.messageCode == AppContext.ErrorCodeForMobileNotVerified && !onblur) {

            submitForm(data, data.response.data.message.messageCode);
          }
          else if (data.response.data.message != null && data.response.data.message.messageCode == AppContext.ErrorCodeForAutoLock && !onblur) {

            submitForm(data, data.response.data.message.messageCode);
          }
          else {
            setAlertMsg(
              data.response.data.resultContent.errors[0].message
            );
            setAlertType("warning");
          }
        }
      }
      else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FieldsAreRequired + "."
        );
        setAlertType("warning");
      }
    }
  };
  const onCaptchaVerify = async (token) => {
    if (!token) {
      console.warn("CAPTCHA expired or reset");
      setCaptchaValid(false);
      return;
    }

    try {
      const result = await CaptchaDataService.verifyCaptcha(token);

      if (result?.isValid) {
        console.log("CAPTCHA verified successfully");
        setCaptchaValid(true);
      } else {
        console.error("CAPTCHA verification failed:", result?.message);
        setCaptchaValid(false);
        captchaRef.current?.reset();
      }
    } catch (err) {
      console.error("CAPTCHA API error", err);
      setCaptchaValid(false);
      captchaRef.current?.reset();
    }
  };


  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      {onlineStatus === false && (
        <div
          className="modal z-index-for-no-internet"
          id="PagewModel"
          style={{ display: "block", backgroundColor: "#54404061" }}
          onContextMenu={(e) => e.preventDefault()}>
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content noInternetpopup">
              <div className="modal-body p-4">
                <div className="text-center mb-3">
                  <img
                    className="h-100px"
                    src={`data:image/png;base64,${noInternetImg}`}
                  />
                </div>
                <div className="mt-3">
                  <h6 className="font-22 mb-1 pt-2 text-center">
                    {" "}
                    {selectedLanguage.LstLanguageCodes.UI_NoInternetConnection}
                  </h6>
                  <p
                    className="text-center my-1"
                    style={{ color: "#000", fontSize: "17px" }}>
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_PleaseMakeSureYouHaveInternet
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="row"
        style={{
          width: "100% ",
          margin: "0px",
          backgroundColor: "#fdfbfe",
          display: "",
        }}>
        <div className="col-sm-6"></div>
        <div className="col-sm-4"></div>
        <div className="col-sm-2" style={{ paddingRight: "0px" }}></div>
      </div>
      <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-white bordertop d-none">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <a className="navbar-brand" href="#">
            <img src="assets/img/RDocs.png" className="logo" alt="logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <form className="d-flex">
            <select
              className="form-select form-control select-border h-47p"
              style={{ float: "right", width: "auto" }}
              aria-label="Default select example"
              onChange={(e) => handlerLanguageCode(e.target.value)}
              value={languageCode}
              tabIndex="31">
              <option value="da-dk" id="Dansk">
                Dansk
              </option>
              <option value="de-de" id="Deutsch">
                Deutsch
              </option>
              <option value="en-us" id="English">
                English
              </option>
              <option value="es-es" id="Español">
                Español
              </option>
              <option value="fr-fr" id="Français">
                Français
              </option>

              <option value="it-it" id="Italian">
                Italian
              </option>

              <option value="ja-jp" id="Japanese">
                Japanese
              </option>
              <option value="nl-nl" id="Nederlands">
                Nederlands
              </option>
              <option value="pt-pt" id="Português">
                Português
              </option>
            </select>
          </form>
        </div>
      </nav>
      <div className="row  bg-white bordertop fixed-top">
        <div className="container-fluid d-flex justify-content-between align-itmes-center">
          <a className="navbar-brand me-auto" href="#">
            {" "}
            <img src="assets/img/RDocs.png" className="logo" alt="logo" />
          </a>
          <div className="selectdiv">
            {/*  form-control select-border h-47p */}
            <select
              className="selector"
              aria-label="Default select example"
              onChange={(e) => handlerLanguageCode(e.target.value)}
              value={languageCode}
              tabIndex="31">
              <option value="da-dk" id="Dansk">
                Dansk
              </option>
              <option value="de-de" id="Deutsch">
                Deutsch
              </option>
              <option value="en-us" id="English">
                English
              </option>
              <option value="es-es" id="Español">
                Español
              </option>
              <option value="fr-fr" id="Français">
                Français
              </option>
              <option value="it-it" id="Italian">
                Italian
              </option>
              <option value="ja-jp" id="Japanese">
                Japanese
              </option>
              <option value="nl-nl" id="Nederlands">
                Nederlands
              </option>
              <option value="pt-pt" id="Português">
                Português
              </option>
            </select>
          </div>
        </div>
      </div>

      <div className="container-login100" style={{ minHeight: "100vh" }}>
        {/* alerts */}
        <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg}
          setAlertType={setAlertType}></Alert>
        {/* end */}

        <img
          className="wave"
          src="assets/img/wave_yellow.svg"
          style={{ color: "f2d8da" }}
          alt="Wave"
        />
        <main className="login_wrapper my2">
          <div className="container">
            {/* <div className="text-center mb-2">
              <img src="assets/img/RDocs.png" className="logo" alt="logo" />
            </div> */}
            <div className="row login-box-12 container-box">
              {/* <!--  style=" background: #f7fbff80;" --> */}
              <div className="col-lg-12 col-sm-12">
                <div className="login-inner-form ">
                  <div className="details pb-2">
                    <h3 className="font-26">
                      {selectedLanguage.LstLanguageCodes.UI_WelcomeBack}!
                    </h3>
                    {/* <form action="" className=""> */}
                    <div className="form-group input-wrapper">
                      <input
                        type="email"
                        name="email"
                        className="input-text login-text"
                        placeholder={
                          selectedLanguage.LstLanguageCodes.UI_EmailAdress
                        }
                        ref={emailRef}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={(e) => getMFAPassWordPolicyDetails(emailRef, true)}
                      />
                      <span className="fa fa-envelope input-icon text-gray"></span>
                    </div>
                    <div className="form-group input-wrapper">
                      <input
                        type="password"
                        name="email"
                        className="input-text login-text"
                        placeholder={
                          selectedLanguage.LstLanguageCodes.UI_Password
                        }
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span className="fa fa-key input-icon text-gray"></span>
                    </div>

                    <div className="checkbox clearfix d-flex align-items-center justify-content-between">
                      <div
                        className="form-check checkbox-theme justify-content-center ps-1 w-50 "
                        style={{ textAlign: "left" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="rememberMe"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberMe">
                          {selectedLanguage.LstLanguageCodes.UI_Rememberme}
                        </label>
                      </div>
                      <div className="form-check checkbox-theme w-50 ">
                        <a
                          href={
                            `${process.env.REACT_APP_ForgotPasswordLink}` +
                            languageCode +
                            `${process.env.REACT_APP_ForgotPasswordLink1}`
                          }
                          //href="https://rpostdocs.io/forgot-password"
                          className="forgetlink">
                          {selectedLanguage.LstLanguageCodes.UI_ForgotPassword}
                        </a>
                      </div>
                    </div>
                    <div class="m-3" style={{ display: "flex", justifyContent: "center" }}>
                      {/* <Recaptcha
                      ref={captchaRef}
                      onVerify={onCaptchaVerify}
                    /> */}
                      <Captcha
                        ref={captchaRef}
                        onVerify={onCaptchaVerify}
                      />
                    </div>
                    <div className="form-group mb-0 d-flex align-items-center justify-content-center">
                      <button
                        className="btn-md btn-theme btn-block mt-2 w-75 login-btns"
                        style={{
                          boxShadow: "rgb(58 177 109 / 50%) 0px 10px 20px 0px",
                          // background: "#3ab16d", 
                          background: captchaValid ? "#3ab16d" : "#4aa563ff",
                          color: "#ffffff",
                          paddingTop: "6px",
                          opacity: captchaValid ? 1 : .50,
                          cursor: captchaValid ? "pointer" : "not-allowed"
                        }}
                        onClick={submitFormWrapper}
                        disabled={!captchaValid}
                      >
                        {selectedLanguage.LstLanguageCodes.UI_SignIn}
                      </button>
                    </div>
                    <div style={{ marginTop: "5px", fontSize: "15px" }}>
                      <span>{selectedLanguage.LstLanguageCodes.UI_OrSignInWith}</span>
                    </div>
                    <div className="form-group mb-0 d-flex align-items-center justify-content-center mb-3 ">
                      <button
                        style={{
                          boxShadow: "rgb(220 53 69 / 40%) 0px 10px 20px 0px",
                          maxWidth: "357px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={
                          selectedLanguage.LstLanguageCodes.UI_SingleSignOn
                        }
                        className="bg-danger  mt-2 w-75 login-btns"
                        onClick={(e) => {
                          e.preventDefault();
                          SSOSignIn();
                        }}>
                        <i className="fa fa-key login-keyicon"></i>
                        <span>
                          {selectedLanguage.LstLanguageCodes.UI_SingleSignOn}
                        </span>
                      </button>
                    </div>
                    <div className="or_options text-center mb-3">
                      <div className="">
                        <span style={{ fontSize: "15px" }}>
                          {selectedLanguage.LstLanguageCodes.UI_or}
                          <a
                            href={
                              `${process.env.REACT_APP_SignUpLink}` +
                              languageCode
                            }
                            //href="https://rpostdocs.io/#signup"
                            className="ms-1 forgetlink">
                            {" "}
                            {selectedLanguage.LstLanguageCodes.UI_SignUp}
                          </a>{" "}
                        </span>
                      </div>
                    </div>

                    {/* </form> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SignIn;
